import { useStoreActions, useStoreState } from 'easy-peasy';
import { useEffect } from 'react';

export const useNewsData = () => {
    const fetchNews = useStoreActions(actions => actions.news.fetchNews);
    const news = useStoreState(state => state.news.news);

    useEffect(() => {
        fetchNews();
    }, [fetchNews]);


    return {
        news,
        isLoading: news.length === 0,
    };
};